import { render, staticRenderFns } from "./exchangeOrderJoin.vue?vue&type=template&id=4826f735&scoped=true&"
import script from "./exchangeOrderJoin.vue?vue&type=script&lang=js&"
export * from "./exchangeOrderJoin.vue?vue&type=script&lang=js&"
import style0 from "./exchangeOrderJoin.vue?vue&type=style&index=0&id=4826f735&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826f735",
  null
  
)

export default component.exports